import React, { Component } from 'react'
import { Row, Col, Select, Button, DatePicker } from 'antd'
import { connect } from 'react-redux';

// Actions
import { save_asset_log } from './../../actions/employee.edit.action' 

const Option = Select.Option;
class NewAssets extends Component {

    constructor( props ){
        super( props );

        this.state = {
            assets_option: [],
            asset_id: '',
            date_given: '',
            employee_id: 0,
        }

        this.handleSubmit = this.handleSubmit.bind( this );

    }

    handleSubmit(){
        let self = this;
        let temp_data = {
            asset_id: this.state.asset_id,
            user_id: this.state.employee_id,
            date_given: this.state.date_given
        }

        if( temp_data['asset_id'] && temp_data['date_given'] ){
            this.props.save_asset_log( temp_data );

            setTimeout( ()=>{
                self.setState({
                    asset_id: '',
                    date_given: ''
                });
            },500 )

        }

    }

    componentWillMount(){
        if( this.props.onData ){
            this.setState({
                assets_option: this.props.onData,
                employee_id: this.props.employee_id
            })
        }
    }

    render() {

        const listAssetsOp = this.state.assets_option.map( (item, k) => <Option key={ item.asset_id }>{ item.asset_model }</Option> )

        return (
            <div>
                <Row gutter={16}>
                    <Col span={8}>
                        <label>Device Type</label>
                        <Select 
                            showSearch
                            onChange={ (value) => this.setState({ asset_id: value }) }
                            style={{ width: '100%' }}
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }>
                            { listAssetsOp}
                        </Select>
                    </Col>
                    <Col span={6}>
                        <label>Date Given</label>
                        <DatePicker 
                            onChange={ (date, dateString ) => this.setState({ date_given: dateString }) } 
                            style={{ width: '100%' }} />
                    </Col>
                    <Col span={4}>
                        <Button 
                            onClick={ this.handleSubmit }
                            className="mrg_t_20" icon="plus" type="primary">Add</Button>
                    </Col>
                </Row>
            </div>
        )
    }
}


function mapStatetoProps( state ){
    return {
        employeeedit: state.employeeedit
    }
}

export default connect( mapStatetoProps, { save_asset_log } )( NewAssets );


// WEBPACK FOOTER //
// ./src/pages/employee.edit/childs/childs/asset.js